// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__NqiJT","views":"FeedPhotosItem_views__SNXXH"};